import React, { Component } from 'react'
import ColorDropdown from 'components/fulcrum/dropdown/FulcrumColorDropdown'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'

const FormComponent = (props) => {
  const { title, ...colorDropdownProps } = props
  return (
    <FormTitle title={title}>
      <ColorDropdown {...colorDropdownProps }/>
    </FormTitle>
  )
}

export default FormComponent
